<template>
  <div class="container page lottery">
    <van-nav-bar :title="lottery.name" class="nav-bar">
      <template #right>
        <div
          class="right c_k_right"
          @click="showRight"
          v-if="userInfo && userInfo.money !== undefined"
        >
          {{ userInfo.money }}
        </div>
        <img
          :src="lottery.ico"
          v-if="lottery.ico"
          class="c_kk_img"
          @click="toMine"
        />
        <img
          src="/img/neww/userpic.png"
          class="c_kk_img"
          v-else
          @click="toMine"
        />
      </template>
    </van-nav-bar>

    <div class="record">
      <div class="info_c_h">
        <div class="buy-record-link" @click="toBuyRecord">
          購買記錄 <van-icon name="arrow" />
        </div>

        <div class="m1">{{ $t("q25") }}</div>

        <span class="p_number">
          <span>{{ currentExpect }}</span> {{ $t("q26") }}
        </span>

        <div>
          <van-count-down class="c_time" format="mm:ss" :time="time" @finish="check()" />
        </div>
      </div>

      <div class="c_bt_m">
        <div class="left_b">
          <div class="hao">{{ lottery.now_expect }}期</div>
        </div>
      </div>
    </div>

    <div class="history_popup"></div>

    <div class="wrapper">
      <div class="options-bar">
        <div class="put_tit_r">{{ $t("q28") }}</div>

        <div class="order-status-area">
          <transition-group name="order-toast" tag="div" class="order-toast-wrap">
            <div
              class="order-toast"
              :class="'order-toast--' + (t.type || 'normal')"
              v-for="t in orderTips"
              :key="t.id"
            >
              {{ t.text }}
            </div>
          </transition-group>
        </div>

        <div class="game">
          <div class="sumValueTwoSides">
            <div
              class="rectangle large"
              :class="{ active: choose[v.type] }"
              v-for="(v, key) in lottery_peilv_list"
              :key="key"
              @click="choosePlay(v.type, v.name)"
            >
              <div class="c_u_item" :style="{ background: v.color }">
                <img :src="v.img" alt="" />
                <div class="text_k">
                  {{
                    v.name === "big"
                      ? rose
                      : v.name === "small"
                      ? lily
                      : v.name === "one"
                      ? fireworks
                      : balloon
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

            <div class="bottom-bar">
        <div class="wrapper_box active">
          <div class="part_show">
            <div class="put_tit_r put_tit_r--mini">請選擇</div>
            <van-icon name="arrow-down" class="collapse-ico" />
          </div>

          <div class="part_grid">
            <div class="col_left">
              <div class="lbl">積分：</div>
              <div class="lbl">
                總積分：<span class="total_num">{{ totalPoints }}</span>
              </div>
            </div>

            <div class="col_right">
              <div class="amount-wrapper">
                <van-field v-model="money" type="digit" />
              </div>

                            <div class="buy_btn" :class="{ disabled: orderSubmitting || orderSuccessLocked }" @click="jiesuan()">
                {{ orderSubmitting ? "提交中..." : orderSuccessLocked ? "已提交" : "購買" }}
              </div>
            </div>
          </div>
        </div>
      </div>

            <van-popup v-model="active" position="top" :style="{ height: '70%' }">
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <div class="wrapper pop_wrapper">
            <div class="item" v-for="(v, key) in lottery_list" :key="key">
              <div class="left">{{ v.expect }}</div>
              <div class="right font-weight">
                <div class="kuaisan-ball left">
                  <span class="ballBox">{{ v.opencode[0] }}</span>
                  <span class="ballBox">{{ v.opencode[1] }}</span>
                  <span class="ballBox" style="margin-right: 20px;">{{ v.opencode[2] }}</span>

                  <span class="res-des ">
                    {{ v.opencode[0] + v.opencode[1] + v.opencode[2] }}
                  </span>

                  <span
                    class="middle"
                    :class="calcBgLs(v.opencode[0], v.opencode[1], v.opencode[2], 'type1')"
                  >
                    {{ isBigSum(v.opencode) ? rose : lily }}
                  </span>

                  <span
                    class="middle"
                    :class="calcBgLs(v.opencode[0], v.opencode[1], v.opencode[2], 'type2')"
                  >
                    {{
                      (v.opencode[0] + v.opencode[1] + v.opencode[2]) % 2 === 0
                        ? balloon
                        : fireworks
                    }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </van-pull-refresh>
      </van-popup>
    </div>

    <van-popup v-model="showModel" position="right" :style="{ width: '70%', height: '100%' }">
      <div class="list">
        <div
          class="item"
          v-for="(i, index) in gameitemData"
          :key="index"
          @click="tabList(i.id, i.key)"
        >
          <div>{{ $t("q29") }}</div>
          <div style="margin: 15px 0 0 15px;">
            <div
              style="height: 86px;background-color: #fff;width: 60px;display: flex;align-items: center;border-radius: 8px;"
            >
              <van-image width="60" height="61" :src="i.ico" />
            </div>
            <div style="font-size: 14px;">{{ i.name }}</div>
          </div>
        </div>
      </div>
    </van-popup>

  </div>
</template>

<script>
var time;
var count = 0;

export default {
  data() {
    return {
      showModel: false,

      rose: "遊艇",
      lily: "跑車",
      fireworks: "火箭",
      balloon: "飛機",

      orderTips: [],
      orderTipSeq: 0,

      orderSubmitting: false,
      orderSuccessLocked: false,
      orderSuccessTimer: null,

      bottomCollapsed: false,

      choose: {
        big: false,
        small: false,
        one: false,
        two: false,
        "3": false,
        "4": false,
        "5": false,
        "6": false,
        "7": false,
        "8": false,
        "9": false,
        "10": false,
        "11": false,
        "12": false,
        "13": false,
        "14": false,
        "15": false,
        "16": false,
        "17": false,
        "18": false,
      },

      playgame: false,
      shopping: false,
      isLoading: false,
      play: {},
      lottery_peilv_list: [],
      lottery_list: {},
      active: false,

      userInfo: {},
      lottery: {},

      shanzi_1: "0",
      shanzi_2: "0",
      shanzi_3: "0",

      sum: 0,
      size: "",
      double: "",
      time: 0,

      shopchoose: this.$t("reservation.no_choose"),
      gameitem: "",
      formData: [],
      money: "",

      ids: 11,
      keys: 5,
      gameitemData: [],

      userTimer: null,
      userInfoFetching: false,
      userInfoLastAt: 0,
    };
  },

  computed: {
    totalPoints() {
      const m = parseFloat(this.money || 0);
      const n = this.formData.length;
      if (isNaN(m) || n <= 0) return 0;
      return m * n;
    },

    currentExpect() {
      const v =
        this.lottery && this.lottery.now_expect ? String(this.lottery.now_expect) : "";
      if (!v) return "";
      const n = Number(v);
      return Number.isFinite(n) ? String(n + 1) : v;
    },
  },

  mounted() {
    if (this.userTimer) {
      clearInterval(this.userTimer);
      this.userTimer = null;
    }
    this.userTimer = setInterval(() => {
      this.getUserInfo(false);
    }, 10000);
  },

  beforeDestroy() {
    if (this.userTimer) {
      clearInterval(this.userTimer);
      this.userTimer = null;
    }
    if (time) {
      clearInterval(time);
      time = null;
    }

    if (this.orderSuccessTimer) {
      clearTimeout(this.orderSuccessTimer);
      this.orderSuccessTimer = null;
    }

    if (this.orderTips && this.orderTips.length) {
      this.orderTips.forEach((t) => {
        if (t && t.timer) clearTimeout(t.timer);
      });
    }
  },

  methods: {
    toggleBottomBar() {
      this.bottomCollapsed = !this.bottomCollapsed;
    },

    showOrderTip(text, type = "normal") {
      const msg = (text && String(text).trim()) ? String(text).trim() : "提示";
      const id = `${Date.now()}_${++this.orderTipSeq}`;

      if (this.orderTips.length >= 5) {
        const old = this.orderTips.shift();
        if (old && old.timer) clearTimeout(old.timer);
      }

      const item = { id, text: msg, type: type, timer: null };
      this.orderTips.push(item);

      item.timer = setTimeout(() => {
        const idx = this.orderTips.findIndex((x) => x.id === id);
        if (idx !== -1) this.orderTips.splice(idx, 1);
      }, 3000);
    },

    isHardOrderRejectMsg(msg) {
      const s = String(msg || "");
      return /餘額不足|余额不足|密碼|密码|錯誤|错误|封盤|封盘|停盤|停盘|維護|维护|禁止|關閉|关闭|風控|风控|不可下單|不可下单/i.test(s);
    },

    toMine() {
      this.$router.push("/Mine");
    },
    back() {
      return window.history.back();
    },
    toBuyRecord() {
      this.$router.push("/GameRecord");
    },

    sumOpenCode(opencode) {
      if (!opencode || !opencode.length) return 0;
      return (opencode[0] || 0) + (opencode[1] || 0) + (opencode[2] || 0);
    },
    isBigSum(opencode) {
      const s = this.sumOpenCode(opencode);
      return s >= 11 && s <= 18;
    },

    doSub() {
      if (this.orderSubmitting) return false;

      if (this.orderSuccessLocked) {
        this.showOrderTip("請勿重複提交", "warn");
        return false;
      }

      if (this.money === "0") {
        this.$toast(this.$t("reservation.money_err"));
        return false;
      }
      if (this.formData.length === 0) {
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      } else if (this.money === "") {
        this.$toast(this.$t("reservation.price_place"));
        return false;
      } else {
        if (this.userInfo.money - this.money * this.formData.length < 0) {
          this.$toast(this.$t("reservation.balance_enough"));
          return false;
        } else {
          this.orderSubmitting = true;
          this.showOrderTip("提交中...", "normal");

          this.$http({
            method: "post",
            data: {
              item: this.gameitem,
              money: this.money,
              lid: this.lottery.id,
              mid: this.userInfo.id,
              expect: this.currentExpect || this.lottery.now_expect,
            },
            url: "game_place_order",
          })
            .then((res) => {
              if (res && res.code === 401) {
                this.$toast(res.msg);
                return;
              }

              const msg = String(res && res.msg ? res.msg : "");

              if (this.isHardOrderRejectMsg(msg)) {
                this.showOrderTip(msg || "下單失敗", "warn");
                return;
              }

              this.showOrderTip("下單成功", "success");
              this.bottomCollapsed = false;
              this.orderSuccessLocked = true;

              if (this.orderSuccessTimer) {
                clearTimeout(this.orderSuccessTimer);
                this.orderSuccessTimer = null;
              }

              this.orderSuccessTimer = setTimeout(() => {
                this.orderSuccessLocked = false;
                this.orderSuccessTimer = null;
              }, 3000);

              this.allClear();
              this.getUserInfo(true);
            })
            .catch(() => {
              this.showOrderTip("網絡異常，請到購買記錄確認", "warn");
            })
            .finally(() => {
              this.orderSubmitting = false;
            });

          return true;
        }
      }
    },

    allClear() {
      for (var i = 0; i < this.formData.length; i++) {
        this.choose[this.formData[i]["type"]] = false;
      }
      this.formData.length = 0;
      this.money = "";
      this.shopchoose = this.$t("reservation.no_choose");
      this.gameitem = "";
      this.shopping = false;
    },

    showRight() {
      this.showModel = true;
    },
    jiesuan() {
      return this.doSub();
    },

    choosePlay(type, name) {
      if (this.choose[type] === true) {
        this.choose[type] = false;
        for (var i = 0; i < this.formData.length; i++) {
          if (type === this.formData[i]["type"]) {
            this.formData.splice(i, 1);
          }
        }
      } else if (this.choose[type] === false) {
        this.formData.push({ name: name, type: type });
        this.choose[type] = true;
      }

      if (this.formData.length === 1) {
        this.shopping = true;
      }

      if (this.formData.length >= 1) {
        for (var j = 0; j < this.formData.length; j++) {
          if (j === 0) {
            this.shopchoose = this.formData[j]["name"];
            this.gameitem = this.formData[j]["type"];
          } else {
            this.shopchoose += "," + this.formData[j]["name"];
            this.gameitem += "," + this.formData[j]["type"];
          }
        }
      } else {
        this.shopchoose = this.$t("reservation.no_choose");
        this.gameitem = "";
        this.shopping = false;
      }

      this.bottomCollapsed = false;
    },

    check() {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
      } else {
        if (time) {
          clearInterval(time);
          time = null;
        }

        time = window.setInterval(() => {
          setTimeout(() => {
            this.getUserInfo(false);
            this.getLotteryInfo();
            this.getLotteryList();

            count++;
            if (count > 5) {
              clearInterval(time);
              time = null;
              count = 0;
            }
          }, 0);
        }, 300);
      }
    },

    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.getLotteryList();
        this.isLoading = false;
      }, 200);
    },

    getUserInfo(force = false) {
      if (this.userInfoFetching) return;

      const now = Date.now();
      if (!force && now - this.userInfoLastAt < 1500) return;
      this.userInfoLastAt = now;

      this.userInfoFetching = true;

      this.$http({
        method: "get",
        url: "user_info",
      })
        .then((res) => {
          if (res.code === 200) {
            this.userInfo = res.data;
            if (this.userInfo.is_online != 1) {
              localStorage.clear();
              this.$router.push({ path: "/Login" });
            }
          } else if (res.code === 401) {
            this.$toast(res.msg);
          }
        })
        .catch(() => {})
        .then(() => {
          this.userInfoFetching = false;
        });
    },

    getLotteryPeilv() {
      this.$http({
        method: "get",
        data: { id: this.ids },
        url: "lottery_get_peilv",
      }).then((res) => {
        if (res.code === 200) {
          const lottery_peilv_list = res.data || [];

          const iconMap = {
            one:   { img: "/img/neww/huojian.gif", color: "#8948fb" },
            two:   { img: "/img/neww/love.gif",    color: "#ff6398" },
            big:   { img: "/img/neww/youting.gif", color: "#2196f3" },
            small: { img: "/img/neww/meigui.gif",  color: "#ff7d73" },
          };

          const order = ["one", "two", "big", "small"];

          const clist = lottery_peilv_list.map((itemc) => {
            const k = itemc.name || itemc.type;
            const ext = iconMap[k] || {};
            return { ...itemc, ...ext };
          });

          clist.sort((a, b) => {
            const ka = a.name || a.type;
            const kb = b.name || b.type;
            const ia = order.indexOf(ka);
            const ib = order.indexOf(kb);
            return (ia === -1 ? 999 : ia) - (ib === -1 ? 999 : ib);
          });

          this.lottery_peilv_list = clist;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },

    getLotteryList() {
      this.$http({
        method: "get",
        data: { key: this.keys },
        url: "lottery_get_one_list",
      }).then((res) => {
        if (res.code === 200) {
          this.lottery_list = res.data;
          this.getLotteryPeilv();
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },

    getGameItem() {
      this.$http({
        method: "get",
        url: "lottery_list",
      }).then((res) => {
        this.gameitemData = res.data;
      });
    },

    tabList(id, key) {
      this.ids = id;
      this.keys = key;
      this.showModel = false;

      this.getUserInfo(true);
      this.getGameItem();
      this.getLotteryInfo();
      this.getLotteryList();
    },

    getLotteryInfo() {
      this.$http({
        method: "get",
        data: { key: this.keys },
        url: "lottery_get_info",
      }).then((res) => {
        if (res.code === 200) {
          if (parseFloat(this.userInfo.money) < parseFloat(res.data.condition)) {
            this.$toast(this.$t("reservation.contact_admin"));
            this.$router.push({ path: "/Home" });
            return false;
          }

          this.lottery = res.data;
          this.time = res.data.second * 1000;

          if (this.time / 1000 === 59) {
            this.$toast(this.$t("reservation.prize_succ") + this.lottery.now_expect);
          }

          this.sum = res.data.opencode[0] + res.data.opencode[1] + res.data.opencode[2];

          this.size = (this.sum % 2 === 1) ? "火箭" : "飛機";
          this.double = (this.sum >= 11 && this.sum <= 18) ? "遊艇" : "跑車";
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },

    calcBgLs(n1, n2, n3, type) {
      let zhi = n1 + n2 + n3;
      if (type === "type1") {
        if (zhi >= 11 && zhi < 18) return "d";
        return "x";
      }
      if (type === "type2") {
        if (zhi % 2 === 0) return "v";
        return "r";
      }
    },
  },

  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserInfo(true);
      this.getGameItem();
      this.getLotteryInfo();
      this.getLotteryList();
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

.order-status-area {
  position: absolute;
  left: 0;
  right: 0;
  top: 72px;
  height: 0;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  pointer-events: none;
  z-index: 20;
}

.order-toast-wrap {
  width: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  pointer-events: none;
  z-index: 20;
}

.order-toast {
  max-width: calc(100vw - 56px);
  min-width: 180px;
  padding: 10px 18px;
  background: rgba(18, 18, 18, 0.78);
  border: 1px solid rgba(230, 185, 138, 0.45);
  border-radius: 18px;
  line-height: 1.2;
  text-align: center;
  font-weight: 900;
  letter-spacing: 1px;
  word-break: break-word;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.45);
}

.order-toast--success {
  color: #1cff68;
  font-size: 40px;
  text-shadow: 0 0 8px rgba(28, 255, 104, 0.45), 0 2px 10px rgba(0, 0, 0, 0.75);
}

.order-toast--normal {
  color: #e6b98a;
  font-size: 32px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.75);
}

.order-toast--warn {
  color: #ff4d67;
  font-size: 32px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.75);
}

.order-toast-enter-active,
.order-toast-leave-active {
  transition: all 0.18s ease;
}

.order-toast-enter,
.order-toast-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

.lottery {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #1f1c1f url("/img/neww/room_bg.gif") no-repeat;
  background-size: 94% auto;
  background-position: center 120px;
}

.record {
  flex: 0 0 auto;
  padding-left: 20px;
  padding-right: 20px;
  z-index: 1;
}

.wrapper {
  position: relative;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding-bottom: 190px;
  transition: padding-bottom 0.22s ease;
}

.wrapper.wrapper--collapsed {
  padding-bottom: 132px;
}

.options-bar {
  position: relative;
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.options-bar .game {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 260px;
  touch-action: pan-y;
}

.wrapper.wrapper--collapsed .options-bar .game {
  padding-bottom: 150px;
}

.buy_btn.disabled {
  opacity: 0.7;
  pointer-events: none;
}

.c_kk_img {
  height: 56px;
  width: 56px;
  border-radius: 50%;
  border: 2px solid #766350;
  margin-left: 20px;
}

.info_c_h {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: flex-start;
  color: #fff;
  padding: 60px 30px 10px;

  .m1 {
    padding-bottom: 16px;
  }

  .p_number {
    padding-bottom: 10px;
    font-size: 30px;
    span {
      font-weight: bold;
      font-size: 36px;
    }
  }
}

.buy-record-link {
  position: absolute;
  top: 18px;
  right: 22px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 26px;
  color: #ffffff;
  opacity: 0.95;
  z-index: 3;
  padding: 6px 8px;
  border-radius: 10px;
}
.buy-record-link:active { opacity: 0.75; }
::v-deep .buy-record-link .van-icon {
  font-size: 24px;
  color: #ffffff;
}

.c_bt_m {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 60px 10px 0 30px;

  .left_b {
    display: inline-flex;
    align-items: center;
    color: #fff;

    .hao { font-size: 24px; }

    .bn {
      padding: 0 10px;
      border-radius: 30px;
      margin-left: 10px;
      font-size: 20px;

      &.d { background: #8948fb; }
      &.x { background: #ff6398; }
      &.v { background: #2196f3; }
      &.r { background: #ff7d73; }
    }
  }
}

.nav-bar .right {
  padding-left: 8px;
  padding-right: 8px;
  color: #e6b98a;
  font-size: 36px;
  border-radius: 10px;
  line-height: 60px;
}

.lottery .van-nav-bar {
  background: linear-gradient(to bottom, #1f1c1f 0, #1f1c1f 100%);
}

.van-count-down {
  color: #fff;
  font-size: 28px;
  margin-top: 10px;
  float: right;
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 6px;
}

.put_tit_r {
  font-weight: bold;
  color: #e6b98a;
  font-size: 28px;
  padding-left: 16px;
  position: relative;
  margin: 20px;

  &::before {
    content: "";
    display: block;
    position: absolute;
    width: 8px;
    height: 30px;
    background: linear-gradient(to right, #ff7a8d 0%, #ff4d67 100%);
    left: 0;
    top: 6px;
  }
}

.sumValueTwoSides {
  display: flex;
  padding: 10px 0 20px;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;

  .c_u_item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 40px 20px 10px;
    border: 4px solid transparent;

    img { width: 130px; }
  }
}

.rectangle { overflow: hidden; }

.rectangle.large {
  width: calc(50% - 4vw) !important;
  text-align: center;
  background: #fff;
  box-shadow: 0 4px 24px 0 rgba(0, 0, 0, .1);
  margin: 0 0 4vw 20px;
  width: 20%;
  border-radius: 20px;
  color: #fff;

  &.active {
    position: relative;

    &::after {
      content: "";
      background: url(/img/neww/ico_yes.png) 100% 100% no-repeat;
      background-size: 50px auto;
      width: 60px;
      height: 60px;
      position: absolute;
      bottom: 2px;
      right: 2px;
      display: block;
    }

    .c_u_item {
      background-color: #212121 !important;
      color: #f3c7a2 !important;
      box-sizing: border-box;
      border: 4px solid #766350;
    }
  }
}

.bottom-bar {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 96px;
  width: auto;
  max-width: none;
  height: auto;
  transform: none;
  z-index: 99;
  padding: 0 20px;
  box-sizing: border-box;
}

.wrapper_box {
  width: 100%;
  box-sizing: border-box;
  background: linear-gradient(120deg, #212121, #313131);
  transform: none;
  padding: 10px 14px 14px;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;

  &.active { transform: none; }

  .put_tit_r--mini { margin: 10px 0 0 0; }

  .part_show {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 6px 6px;
    cursor: default;
    user-select: none;
  }

  .collapse-ico {
    font-size: 26px;
    color: #766350;
  }

  .part_grid {
    display: flex;
    align-items: stretch;
    padding: 6px 6px 0;
    gap: 12px;
  }

  .col_left {
    flex: 0 0 38%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 6px 0;
  }

  .lbl {
    position: relative;
    padding-left: 16px;
    color: #c5c5c5;
    font-size: 28px;
    line-height: 44px;

    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 8px;
      width: 6px;
      height: 28px;
      border-radius: 3px;
      background: linear-gradient(to bottom, #ff7a8d 0%, #ff4d67 100%);
    }
  }

  .total_num {
    margin-left: 8px;
    color: #ff4d67;
    font-weight: 700;
    font-size: 30px;
  }

  .col_right {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 6px 0 0;
  }

  .amount-wrapper { width: 100%; }

  ::v-deep .van-cell {
    margin: 0;
    border: 1px solid #766350;
    background: linear-gradient(120deg, #212121, #313131);
    border-radius: 10px;
    padding: 8px 14px;
  }

  ::v-deep .van-field__control {
    color: #e6b98a;
    font-size: 28px;
  }

  .buy_btn {
    margin-top: 12px;
    width: 100%;
    text-align: center;
    padding: 14px 0;
    border-radius: 10px;
    background: linear-gradient(180deg, #efcba7, #dcab76);
    color: #333;
    font-weight: 700;
    font-size: 28px;
  }
}

.bottom-expand-trigger {
  position: fixed;
  left: 50%;
  right: auto;
  bottom: 100px;
  width: 100%;
  max-width: 540px;
  transform: translateX(-50%);
  z-index: 99;
  padding: 0 20px;
  box-sizing: border-box;
  pointer-events: auto;
}

.bottom-expand-inner {
  background: linear-gradient(120deg, #212121, #313131);
  border: 1px solid rgba(118, 99, 80, 0.55);
  border-radius: 16px;
  padding: 10px 14px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.45);
}

.put_tit_r--trigger {
  margin: 0 !important;
}

.bottom-expand-inner .collapse-ico {
  font-size: 26px;
  color: #766350;
}

@media screen and (max-height: 640px) {
  .record {
    padding-left: 10px;
    padding-right: 10px;
  }

  .info_c_h {
    padding: 26px 22px 6px;

    .m1 {
      padding-bottom: 8px;
      font-size: 24px;
    }

    .p_number {
      padding-bottom: 6px;
      font-size: 24px;
      span {
        font-size: 30px;
      }
    }
  }

  .buy-record-link {
    top: 8px;
    right: 16px;
    font-size: 20px;
    padding: 3px 5px;
  }

  ::v-deep .buy-record-link .van-icon {
    font-size: 20px;
  }

  .van-count-down {
    font-size: 22px;
    margin-top: 4px;
    padding: 5px 8px;
  }

  .c_bt_m {
    padding: 8px 10px 0 22px;

    .left_b {
      .hao { font-size: 20px; }
    }
  }

  .wrapper {
    padding-bottom: 144px;
  }

  .wrapper.wrapper--collapsed {
    padding-bottom: 112px;
  }

  .put_tit_r {
    font-size: 22px;
    margin: 4px 20px 4px;

    &::before {
      width: 6px;
      height: 24px;
      top: 5px;
    }
  }

  .options-bar .game {
    padding-bottom: 225px;
  }

  .wrapper.wrapper--collapsed .options-bar .game {
    padding-bottom: 104px;
  }

  .sumValueTwoSides {
    padding: 2px 0 6px;
  }

  .rectangle.large {
    width: calc(50% - 15px) !important;
    margin: 0 0 8px 10px;
    border-radius: 14px;
  }

  .sumValueTwoSides .c_u_item {
    height: 64px;
    padding: 5px 18px 5px 7px;
    box-sizing: border-box;
    border-width: 3px;
  }

  .sumValueTwoSides .c_u_item img {
    width: 54px;
  }

  .sumValueTwoSides .text_k {
    font-size: 20px;
    line-height: 23px;
  }

  .rectangle.large.active {
    &::after {
      background-size: 40px auto;
      width: 46px;
      height: 46px;
    }

    .c_u_item {
      border-width: 3px;
    }
  }

  .bottom-bar {
    left: 0;
    right: 0;
    bottom: 100px;
    width: auto;
    max-width: none;
    transform: none;
    padding: 0 20px;
  }

  .wrapper_box {
    padding: 7px 14px 10px;
    border-top-left-radius: 14px;
    border-top-right-radius: 14px;

    .put_tit_r--mini { margin: 4px 0 0 0; }

    .part_show {
      padding: 0 6px 3px;
    }

    .collapse-ico {
      font-size: 22px;
    }

    .part_grid {
      padding: 2px 6px 0;
      gap: 10px;
    }

    .col_left {
      flex: 0 0 36%;
      padding: 2px 0;
    }

    .lbl {
      font-size: 22px;
      line-height: 34px;
      padding-left: 13px;

      &::before {
        width: 5px;
        height: 22px;
        top: 6px;
      }
    }

    .total_num {
      font-size: 24px;
    }

    .col_right {
      padding: 2px 0 0;
    }

    ::v-deep .van-cell {
      border-radius: 8px;
      padding: 5px 10px;
    }

    ::v-deep .van-field__control {
      font-size: 22px;
    }

    .buy_btn {
      margin-top: 8px;
      padding: 8px 0;
      border-radius: 8px;
      font-size: 22px;
    }
  }

  .order-toast--success {
    font-size: 34px;
  }

  .order-toast--normal,
  .order-toast--warn {
    font-size: 28px;
  }

  .bottom-expand-trigger {
    bottom: 100px;
  }

  .bottom-expand-inner {
    border-radius: 14px;
    padding: 8px 14px 10px;
  }
}

@media screen and (max-height: 590px) {
  .info_c_h {
    padding: 20px 20px 5px;

    .m1 {
      padding-bottom: 6px;
      font-size: 22px;
    }

    .p_number {
      padding-bottom: 4px;
      font-size: 22px;
      span {
        font-size: 28px;
      }
    }
  }

  .buy-record-link {
    top: 10px;
    right: 16px;
    font-size: 20px;
  }

  .van-count-down {
    font-size: 20px;
    padding: 4px 7px;
  }

  .c_bt_m {
    padding: 5px 10px 0 20px;
  }

  .wrapper {
    padding-bottom: 134px;
  }

  .wrapper.wrapper--collapsed {
    padding-bottom: 100px;
  }

  .put_tit_r {
    font-size: 20px;
    margin: 3px 20px 3px;
  }

  .options-bar .game {
    padding-bottom: 215px;
  }

  .wrapper.wrapper--collapsed .options-bar .game {
    padding-bottom: 94px;
  }

  .sumValueTwoSides {
    padding-top: 2px;
  }

  .rectangle.large {
    width: calc(50% - 13px) !important;
    margin: 0 0 6px 9px;
    border-radius: 12px;
  }

  .sumValueTwoSides .c_u_item {
    height: 56px;
    padding: 4px 14px 4px 6px;
  }

  .sumValueTwoSides .c_u_item img {
    width: 44px;
  }

  .sumValueTwoSides .text_k {
    font-size: 18px;
    line-height: 21px;
  }

  .bottom-bar {
    left: 0;
    right: 0;
    bottom: 94px;
    width: auto;
    max-width: none;
    transform: none;
    padding: 0 20px;
  }

  .wrapper_box {
    padding: 6px 12px 8px;

    .part_grid {
      gap: 8px;
    }

    .lbl {
      font-size: 20px;
      line-height: 30px;
    }

    .total_num {
      font-size: 22px;
    }

    ::v-deep .van-cell {
      padding: 4px 9px;
    }

    .buy_btn {
      margin-top: 6px;
      padding: 7px 0;
      font-size: 20px;
    }
  }

  .bottom-expand-trigger {
    bottom: 94px;
  }
}

@media screen and (max-height: 540px) {
  .record {
    padding-left: 8px;
    padding-right: 8px;
  }

  .info_c_h {
    padding: 16px 18px 4px;

    .m1 {
      padding-bottom: 4px;
      font-size: 20px;
    }

    .p_number {
      padding-bottom: 3px;
      font-size: 20px;
      span {
        font-size: 24px;
      }
    }
  }

  .buy-record-link {
    top: 6px;
    right: 14px;
    font-size: 18px;
  }

  .van-count-down {
    font-size: 18px;
    margin-top: 2px;
    padding: 3px 6px;
  }

  .c_bt_m {
    padding: 3px 8px 0 18px;

    .left_b {
      .hao { font-size: 18px; }
    }
  }

  .put_tit_r {
    font-size: 18px;
    margin: 2px 18px 3px;

    &::before {
      width: 5px;
      height: 20px;
      top: 4px;
    }
  }

  .rectangle.large {
    margin: 0 0 5px 8px;
  }

  .sumValueTwoSides .c_u_item {
    height: 50px;
    padding: 3px 12px 3px 6px;
  }

  .sumValueTwoSides .c_u_item img {
    width: 38px;
  }

  .sumValueTwoSides .text_k {
    font-size: 16px;
    line-height: 19px;
  }

  .bottom-bar {
    left: 0;
    right: 0;
    bottom: 88px;
    width: auto;
    max-width: none;
    transform: none;
    padding: 0 20px;
  }

  .wrapper_box {
    padding: 5px 10px 7px;

    .part_show {
      padding: 0 5px 2px;
    }

    .part_grid {
      padding: 1px 5px 0;
      gap: 7px;
    }

    .lbl {
      font-size: 18px;
      line-height: 28px;
    }

    .total_num {
      font-size: 20px;
    }

    ::v-deep .van-cell {
      padding: 3px 8px;
    }

    ::v-deep .van-field__control {
      font-size: 18px;
    }

    .buy_btn {
      margin-top: 5px;
      padding: 6px 0;
      font-size: 18px;
    }
  }
}

</style>